import { useState } from 'react';
import {
    Box,
    Paper,
    InputBase,
    IconButton
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import FilterListIcon from '@mui/icons-material/FilterList';
import SortIcon from '@mui/icons-material/Sort';
import { useDialog } from 'hooks';
import { FilterDialog } from 'components';

export function SearchInput({
    onSearch,
    onFilter,
    onSort,
    currentSort = 'closestTime',
    currentFilters = {},
    placeholder = "Search deal or restaurant...",
    showFilters = true
}) {
    const [query, setQuery] = useState('');
    const [filterDialogOpen, setFilterDialogOpen] = useState(false);
    const { select } = useDialog();

    const sortOptions = [
        { value: 'closestTime', label: 'Closest Time' },
        { value: 'lowestPrice', label: 'Lowest Price' },
        { value: 'mostLiked', label: 'Most Liked' },
        { value: 'mostViewed', label: 'Most Viewed' },
        { value: 'highestRated', label: 'Highest Rated' },
    ];

    const handleSearch = () => {
        onSearch && onSearch(query);
    };

    const handleClear = () => {
        setQuery('');
        onSearch && onSearch('');
    };

    const handleFilter = () => {
        setFilterDialogOpen(true);
    };

    const handleFiltersChange = (newFilters) => {
        onFilter && onFilter(newFilters);
    };

    const handleFilterDialogClose = () => {
        setFilterDialogOpen(false);
    };

    const hasActiveFilters = Object.values(currentFilters).some(Boolean);

    const handleSort = async () => {
        const result = await select({
            title: "Sort",
            options: sortOptions,
            selectedValue: currentSort,
        });
        onSort && onSort(result.value);
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Paper
                elevation={0}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    overflow: 'hidden',
                    border: '2px solid black',
                    borderRadius: '10px',
                }}
            >
                <InputBase
                    sx={{
                        ml: 1,
                        flex: 1,
                        transition: 'width 300ms ease-in-out',
                        py: 1,
                    }}
                    placeholder={placeholder}
                    slotProps={{
                        input: { 'aria-label': 'search' },
                    }}
                    value={query}
                    onChange={(event) => setQuery(event.target.value)}
                    onKeyDown={(event) => {
                        if (event.key === 'Enter') {
                            handleSearch();
                        }
                    }}
                />

                {query && (
                    <IconButton
                        aria-label='clear'
                        onClick={handleClear}
                        size="small"
                    >
                        <ClearIcon />
                    </IconButton>
                )}
                <IconButton
                    aria-label='search'
                    onClick={handleSearch}
                    size="small"
                >
                    <SearchIcon />
                </IconButton>
                {showFilters && (
                    <>
                        <IconButton
                            aria-label='filter'
                            onClick={handleFilter}
                            size="small"
                            sx={{
                                color: hasActiveFilters ? 'primary.main' : 'inherit'
                            }}
                        >
                            <FilterListIcon />
                        </IconButton>
                        <IconButton
                            aria-label='sort'
                            onClick={handleSort}
                            size="small"
                            sx={{
                                color: currentSort ? 'primary.main' : 'inherit' // Highlight when sorted
                            }}
                        >
                            <SortIcon />
                        </IconButton>
                    </>
                )}
            </Paper>

            <FilterDialog
                open={filterDialogOpen}
                title="Filter Deals"
                filters={currentFilters}
                onFiltersChange={handleFiltersChange}
                onClose={handleFilterDialogClose}
            />
        </Box>
    );
}